import Search from "./components/Header/Search";
import "mapbox-gl/dist/mapbox-gl.css";

function App() {
  return (
    <>
      <Search />
    </>
  );
}

export default App;
